import axiosInstance from '@/utils/api.js'

var state = {
  services: []
}

var getters = {
  SERVICES: (state) => {
    return state.services
  }
}

var mutations = {
  SET_SERVICES: (state, payload) => {
    state.services = payload || []
  }
}

var actions = {
  GET_SERVICES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services')
    if (result.status === 200) {
      context.commit('SET_SERVICES', result.data)
    }
  },
  GET_SERVICE_CHARGE_POLICY: async (context, payload) => {
    return axiosInstance.get('tariffing/services/charge_policy?service_id=' + payload.service_id)
  },
  DELETE_SERVICES: (context, payload) => {
    return axiosInstance.delete('/tariffing/services?service_id=' + payload)
  },
  UPDATE_SUPPLIER_ID: (context, payload) => {
    return axiosInstance.put('/tariffing/services/set_supplier_id', payload)
  },
  UPDATE_MULTI_LINKING: (context, payload) => {
    return axiosInstance.put('/tariffing/services/set_multi_linking', payload)
  },
  UPDATE_CHARGE_POLICY: (context, payload) => {
    return axiosInstance.put('/tariffing/services/set_charge_policy', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/service.js